'use client';
import cn from 'classnames';

import styles from './cursor.module.scss';

interface CursorProps {
  showCursor: boolean;
  isZoomed: boolean;
  mouseY: number;
  mouseX: number;
}

export default function Cursor({ showCursor, isZoomed, mouseY, mouseX }: Readonly<CursorProps>) {
  return (
    <div
      className={cn(styles.cursor, { [styles.showCursor]: showCursor })}
      style={{
        top: `${mouseY}px`,
        left: `${mouseX}px`,
      }}
    >
      <div
        className={cn({
          [styles.zoomOut]: isZoomed,
          [styles.zoomIn]: !isZoomed,
        })}
      ></div>
    </div>
  );
}
